export const SET_CAPACITY_ALL = 'SET_CAPACITY_ALL';
export const SET_PROFILE_DETAILS = 'SET_PROFILE_DETAILS';
export const SET_CAPACITY_SELECTED_DETAILS = 'SET_CAPACITY_SELECTED_DETAILS';
export const IS_OFFICE_STATE_SELECTED = 'IS_OFFICE_STATE_SELECTED';
export const IS_CORRESPONDENCE_STATE_SELECTED = 'IS_CORRESPONDENCE_STATE_SELECTED';



